/* ===== FONTSOURCE GLOBAL IMPORT ===== */
import "@fontsource/inter";
import "@fontsource/lora";
import "@fontsource/roboto";
import "@fontsource/source-serif-4";
import "@fontsource/nunito";
import "@fontsource/merriweather";
import "@fontsource/playfair-display";
import "@fontsource/libre-baskerville";
import "@fontsource/pt-serif";
import "@fontsource/raleway";
import "@fontsource/open-sans";
import "@fontsource/work-sans";
import "@fontsource/ubuntu";
import "@fontsource/poppins";
import "@fontsource/montserrat";
import "@fontsource/noto-sans";
import "@fontsource/noto-serif";
import "@fontsource/crimson-pro";
import "@fontsource/eb-garamond";
import "@fontsource/spectral";
import "@fontsource/karla";
import "@fontsource/mulish";
import "@fontsource/quicksand";
import "@fontsource/cabin";
import "@fontsource/fira-sans";
import "@fontsource/manrope";
import "@fontsource/hind";
import "@fontsource/hind-madurai";
import "@fontsource/noto-sans-display";
import "@fontsource/noto-serif-display";

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

/* ── Register push notification service worker ── */
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(err => {
      console.warn("SW registration failed:", err);
    });
  });
}